<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_0_191)">
      <path
        d="M15.2 247.2C15.2 247.2 27.2 313.424 88 345.384C148.8 377.344 224.448 363.2 285.88 353.336C347.312 343.472 388.752 297.336 387.824 242.216C386.896 187.096 338.104 182.136 303.824 127.08C269.544 72.0239 268.8 51.4879 209.904 26.3999C151.008 1.31193 70.968 43.5359 36.8 117.8C2.63203 192.064 15.2 247.2 15.2 247.2Z"
        :fill="color"
      />
      <path
        opacity="0.7"
        d="M15.2 247.2C15.2 247.2 27.2 313.424 88 345.384C148.8 377.344 224.448 363.2 285.88 353.336C347.312 343.472 388.752 297.336 387.824 242.216C386.896 187.096 338.104 182.136 303.824 127.08C269.544 72.0239 268.8 51.4879 209.904 26.3999C151.008 1.31193 70.968 43.5359 36.8 117.8C2.63203 192.064 15.2 247.2 15.2 247.2Z"
        fill="white"
      />
      <path
        d="M78.824 170.224C78.824 170.224 91.096 199.2 96.504 213.928C101.912 228.656 101.408 233.08 101.408 233.08L59.2 231.608C59.2 231.608 55.76 212.952 62.632 196.744C66.6625 187.139 72.1214 178.198 78.824 170.224Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M89.072 220.712C90.456 226.36 91.288 230.352 91.792 233.184L259.52 241.6L315.456 242.4L351.4 242.8C351.4 242.8 304.656 214.88 296.488 204.4C288.32 193.92 288.704 184.552 284.808 178.712C280.912 172.872 264.184 159.2 261.464 151.832C258.744 144.464 258.352 143.272 258.352 143.272L82.848 149.888C82.848 149.888 68.448 159.616 75.448 183.744C75.448 183.744 84.8 203.2 89.072 220.712Z"
        fill="white"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.4"
        d="M94.4 232.8L307.032 234.136V242.608"
        fill="black"
      />
      <path
        d="M127.536 191.632C133.89 202.874 137.712 215.368 138.736 228.24"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.4"
        d="M79.504 179.944L272.984 161.896L258.352 143.272L82.848 149.888L79.504 179.944Z"
        fill="black"
      />
      <path
        d="M385.416 176.632C370.216 141.952 352.096 138.872 352.096 138.872L254.968 142.776C254.873 143.332 254.809 143.893 254.776 144.456C254.639 146.964 254.744 149.48 255.088 151.968C255.216 165.224 257.192 197.568 272.768 210.568C277.352 214.402 282.661 217.271 288.38 219.006C294.098 220.741 300.107 221.305 306.048 220.664C306.601 221.95 306.924 223.323 307 224.72C307.432 234.688 307.432 242.064 307.432 242.064L382.448 242.928C382.448 242.928 400.584 211.32 385.416 176.632ZM265.472 180.544C266.04 181.544 266.632 182.56 267.264 183.6C275.776 197.584 289.832 209.2 300.992 216.832C286.216 213.464 265.224 204.472 265.472 180.544Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M278.16 159.24C288.992 171.936 307.248 188.8 332.8 197.048C376.896 211.336 388.08 208.248 388.08 208.248"
        stroke="#7D7D7D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M266.344 143.008C268.332 146.363 270.52 149.596 272.896 152.688"
        stroke="#7D7D7D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M372.568 202.648C375.155 203.533 377.845 204.36 380.64 205.128"
        stroke="#7D7D7D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M311.696 145.496C311.696 145.496 320.984 180.208 362.984 198.88"
        stroke="#7D7D7D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M42.336 177.472C42.336 177.472 31.136 197.768 31.136 214.864C31.0795 220.029 31.6381 225.183 32.8 230.216L65.304 231.816C60.248 213.048 68.504 188.48 90.688 172.368C116.064 153.968 123.008 148.6 123.008 148.6L47.688 151.8C47.688 151.8 42.088 155.272 31.928 171.8C21.768 188.328 26.056 214.8 26.056 214.8C26.8245 207.776 28.4361 200.871 30.856 194.232C33.2084 187.767 37.1575 182.001 42.336 177.472Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M73.784 187.112C66.288 198.505 62.5836 211.976 63.2 225.6"
        stroke="#7D7D7D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.96 209.312C41.2418 212.63 40.8744 216.014 40.864 219.408"
        stroke="#7D7D7D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M81.24 154.808C81.24 154.808 54.208 174.808 44.384 201.088"
        stroke="#7D7D7D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M138.752 148.096C138.752 148.096 138.216 161.184 122.464 170.264C106.712 179.344 99.496 175.864 84.272 181.744C69.048 187.624 64.272 198.04 64.272 198.04C64.272 198.04 81.072 179.88 109.944 180.144C138.816 180.408 165.224 162.544 174.04 146.76L138.752 148.096Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M178.016 162.52C178.016 162.52 173.744 168.664 173.744 172.12C173.744 175.576 173.208 181.464 173.208 181.464C173.208 181.464 178.808 178.528 188.96 172.12C199.112 165.712 213.8 152.352 225.824 150.216C237.848 148.08 248.224 152.888 252.264 155.56C256.304 158.232 259.208 160.36 259.208 160.36C259.208 160.36 252.264 147.56 240.512 144.064L204.72 145.136C204.72 145.136 191.104 147.024 178.016 162.52Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M172.936 169.728L171.072 182.28C171.072 182.28 167.864 178.008 172.936 169.728Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M124.864 185.216C124.864 185.216 122.192 176.936 115.52 171.864C108.848 166.792 88.8 160.384 82.664 163.584C76.528 166.784 77.328 177.184 77.328 177.184C77.328 177.184 79.728 171.304 85.328 170.504C90.928 169.704 102.928 177.984 110.968 182.504C119.008 187.024 124.864 185.216 124.864 185.216Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M123.8 178.808L126.472 185.488C126.472 185.488 128.608 181.744 123.8 178.808Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M221.816 179.08C216.014 177.897 209.997 178.366 204.448 180.432C202.588 183 201.433 186.011 201.099 189.165C200.764 192.318 201.262 195.504 202.541 198.406C203.821 201.307 205.839 203.822 208.393 205.702C210.948 207.581 213.95 208.758 217.101 209.116C220.252 209.473 223.442 209 226.352 207.741C229.263 206.483 231.793 204.484 233.691 201.943C235.589 199.403 236.789 196.41 237.17 193.261C237.551 190.113 237.101 186.92 235.864 184C232.624 182.76 230.2 180.864 221.816 179.08Z"
        :fill="color"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M219.144 202.312C225.338 202.312 230.36 197.291 230.36 191.096C230.36 184.902 225.338 179.88 219.144 179.88C212.95 179.88 207.928 184.902 207.928 191.096C207.928 197.291 212.95 202.312 219.144 202.312Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M229.472 196.328C231.937 196.328 233.936 194.33 233.936 191.864C233.936 189.399 231.937 187.4 229.472 187.4C227.007 187.4 225.008 189.399 225.008 191.864C225.008 194.33 227.007 196.328 229.472 196.328Z"
        fill="white"
      />
      <path
        d="M185.76 211.392C185.948 201.966 189.232 192.864 195.104 185.488C207.416 169.848 222.88 176.136 228.224 178.544C233.568 180.952 243.2 188.424 243.2 188.424L245.6 188.688C245.6 188.688 242.32 192.768 237.32 199.888C231.72 207.888 228.52 212.968 209.816 214.04"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M186.56 212.728C186.56 212.728 187.632 219.128 189.232 216.728C190.832 214.328 191.632 213.792 191.632 213.792L196.712 213.52"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M248.256 185.752C246.656 186.024 243.712 185.216 243.712 185.216C243.712 185.216 247.712 183.352 248.792 182.016C249.872 180.68 250.128 177.744 250.128 177.744C250.128 177.744 247.728 180.68 244.528 181.216C241.328 181.752 236.256 180.68 236.256 180.68C236.256 180.68 240.792 178.544 241.592 177.744C242.392 176.944 243.992 173.2 243.992 173.2C243.992 173.2 238.648 176.936 234.64 177.744C230.632 178.552 231.168 175.344 217.28 174.272C203.392 173.2 190.576 183.872 186.568 205.52C186.568 205.52 192.968 183.616 208.968 182.016C224.968 180.416 234.608 185.752 239.416 187.616C239.864 187.784 240.272 187.928 240.672 188.056C240.35 192.596 239.028 197.008 236.8 200.976C233.944 205.776 231.64 207.912 230.552 208.768C233.024 206.976 241.432 200.376 243.48 192.432C243.821 191.212 244.033 189.96 244.112 188.696C245.92 188.696 247.232 188.04 248.824 187.096C250.54 185.998 251.997 184.54 253.096 182.824C253.096 182.824 249.856 185.488 248.256 185.752Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M230.52 208.8C230.08 209.12 229.824 209.288 229.824 209.288C230.068 209.143 230.3 208.979 230.52 208.8Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M191.104 190.296C191.104 190.296 195.104 177.208 205.792 172.936C216.48 168.664 226.888 172.936 226.888 172.936"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M134.992 216.432C134.992 216.432 129.544 202.032 121.76 194.64C113.976 187.248 103.856 189.192 99.576 196.976C95.296 204.76 95.296 210.2 95.296 210.2C95.296 210.2 97.24 214.872 105.808 220.712C114.376 226.552 124.096 224.6 128.768 223.048"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M113.16 191.152C111.36 192.536 109.862 194.272 108.756 196.256C107.651 198.239 106.962 200.427 106.732 202.685C106.502 204.944 106.735 207.226 107.418 209.391C108.1 211.556 109.218 213.559 110.702 215.278C112.185 216.996 114.004 218.393 116.047 219.384C118.09 220.375 120.313 220.938 122.582 221.04C124.85 221.141 127.115 220.778 129.237 219.973C131.36 219.169 133.297 217.939 134.928 216.36C127.888 199.552 117.6 193.2 113.16 191.152Z"
        :fill="color"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M120.744 196.088C119.307 196.666 118.024 197.57 116.996 198.728C115.967 199.886 115.222 201.267 114.818 202.762C114.414 204.257 114.362 205.826 114.667 207.344C114.972 208.863 115.626 210.29 116.576 211.513C117.526 212.736 118.747 213.722 120.143 214.393C121.539 215.064 123.071 215.402 124.62 215.38C126.168 215.358 127.691 214.977 129.067 214.267C130.444 213.557 131.637 212.537 132.552 211.288C129.645 205.5 125.633 200.336 120.744 196.088Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M113.976 189.192C103.856 186.856 102.304 191.136 98.776 191.912C96.443 192.348 94.0394 192.216 91.768 191.528C91.768 191.528 92.16 194.248 93.72 195.024C94.9623 195.574 96.2684 195.966 97.608 196.192C97.608 196.192 94.496 198.144 91.768 198.144C90.1408 198.145 88.5385 197.744 87.104 196.976C87.104 196.976 89.44 200.472 90.992 201.256C92.2347 201.723 93.5781 201.855 94.888 201.64C94.888 201.64 94.088 203.976 90.216 203.976C88.0818 204.035 85.9598 203.636 83.992 202.808C83.992 202.808 89.048 206.312 90.992 207.48C91.7737 207.934 92.6252 208.256 93.512 208.432C92.4453 209.061 91.2793 209.505 90.064 209.744L88.28 210C88.28 210 91.84 212.792 96.16 215.6C98.636 217.224 101.274 218.586 104.032 219.664C104.032 219.664 97.776 215.16 95.552 210.816C95.456 210.616 95.36 210.408 95.272 210.208L96.016 206C97.344 201.8 100.528 193.896 106.168 191.92C113.952 189.2 124.456 197.76 132.24 210.992C132.264 210.984 124.096 191.528 113.976 189.192Z"
        fill="#263238"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M130.472 204.984C130.472 204.984 124.6 193.496 118.72 187.888C112.84 182.28 104.456 184.4 101.632 188.16"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M131.2 212.312C131.2 212.917 131.021 213.507 130.685 214.01C130.349 214.512 129.872 214.904 129.313 215.135C128.755 215.367 128.141 215.427 127.548 215.309C126.955 215.191 126.41 214.9 125.983 214.473C125.556 214.046 125.265 213.501 125.147 212.908C125.029 212.315 125.089 211.701 125.321 211.143C125.552 210.584 125.944 210.107 126.446 209.771C126.949 209.435 127.54 209.256 128.144 209.256C128.955 209.256 129.732 209.578 130.305 210.151C130.878 210.724 131.2 211.502 131.2 212.312Z"
        fill="white"
      />
      <path d="M307.432 242.064L259.512 241.624L91.792 233.184" fill="black" />
      <path
        d="M20 229.616L266.592 241.856L390.224 243.512"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.136 152.608L377.04 137.824"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.8 108.288L379.64 95.2319"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.4 276.264L312.8 277.336L390.136 275.736"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M32.912 276C32.912 276 152.8 285.336 205.064 283.2C257.328 281.064 327.808 277.28 327.808 277.28L250.4 276.8H134.664L32.912 276Z"
        fill="#263238"
      />
      <path
        d="M29.6 329.6C29.6 329.6 158.136 338.664 230.664 334.4C303.192 330.136 388 325.336 388 325.336"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M288 201.6C288 201.6 325.2 214.888 333.176 218.872C341.152 222.856 348.376 242.832 348.376 242.832L279.736 241.992C279.736 241.992 262.272 219.768 288 201.6Z"
        fill="white"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M333.2 212.8C333.2 212.8 345.2 222.016 349.072 223.552C352.944 225.088 359.568 239.432 364.176 245.576C368.784 251.72 373.4 254.28 371.088 257.576C368.776 260.872 362.384 263.72 354.704 259.624C347.024 255.528 344.464 243.24 342.928 242.216C341.392 241.192 335.504 235.816 334.224 233.256C332.944 230.696 329.6 212.504 333.2 212.8Z"
        fill="white"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M366.48 248.608C366.48 248.608 357.008 244.256 357.264 247.808C357.52 251.36 364.688 254.208 366.736 255.008C368.784 255.808 372.632 256.544 371.344 254.496C370.054 252.282 368.411 250.293 366.48 248.608Z"
        :fill="color"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M259.52 241.6C254.146 239.369 249.509 235.667 246.144 230.92C240.544 222.976 238.944 220.928 233.6 224.768C229.24 227.888 230.984 236.896 231.8 240.2L259.52 241.6Z"
        fill="white"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M315.784 203.544C315.784 203.544 317.832 199.448 321.384 199.448C323.571 199.404 325.728 199.953 327.628 201.036C329.528 202.119 331.1 203.696 332.176 205.6C334.736 210.208 333.2 218.656 336.272 230.696C339.344 242.736 337.296 249.384 333.712 255.272C330.128 261.16 325.52 268.072 323.216 269.352C320.912 270.632 317.32 268.84 316.016 264.488C314.712 260.136 315.216 252.712 316.016 249.128C316.816 245.544 318.832 238.632 318.832 238.632C316.906 233.111 315.869 227.318 315.76 221.472C315.76 221.472 312.944 221.472 312.944 216.608C312.944 211.744 315.016 204.8 315.784 203.544Z"
        fill="white"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M316.04 264.48C316.04 263.424 315.528 259.872 318.6 257.056C321.672 254.24 323.984 252.96 326.032 254.24C328.08 255.52 331.92 257.056 330.64 259.616C329.36 262.176 326.544 267.296 324.496 268.576C322.448 269.856 316.296 271.648 316.04 264.48Z"
        :fill="color"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M294.84 203.456C294.84 203.456 294.04 193.304 285.832 193.304C277.624 193.304 274.312 195.352 273.544 199.448C272.776 203.544 265.856 223 266.88 227.872C267.904 232.744 276.104 255.776 276.616 259.872C277.128 263.968 285.32 269.088 290.216 264.48C295.112 259.872 292.008 250.88 292.008 247.072C292.008 243.264 290.216 227.872 290.216 227.872C290.216 227.872 293.592 224.864 293.848 215.392"
        fill="white"
      />
      <path
        d="M294.84 203.456C294.84 203.456 294.04 193.304 285.832 193.304C277.624 193.304 274.312 195.352 273.544 199.448C272.776 203.544 265.856 223 266.88 227.872C267.904 232.744 276.104 255.776 276.616 259.872C277.128 263.968 285.32 269.088 290.216 264.48C295.112 259.872 292.008 250.88 292.008 247.072C292.008 243.264 290.216 227.872 290.216 227.872C290.216 227.872 293.592 224.864 293.848 215.392"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M285.448 218.296C285.981 218.606 286.388 219.093 286.6 219.672"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M270.464 218.904C270.464 218.904 271.744 215.576 278.92 216.344C280.172 216.47 281.411 216.7 282.624 217.032"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M278.4 263.12C278.4 263.12 276.312 257.56 277.008 253.848C277.704 250.136 282.112 248.752 286.28 249.448C290.448 250.144 292.08 257.56 291.88 261.96C291.68 266.36 283.464 269.84 278.4 263.12Z"
        :fill="color"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M315.784 202.264C315.784 202.264 314.984 195.608 311.944 193.816C308.904 192.024 299.144 190.232 296.584 193.304C294.024 196.376 295.304 211.992 294.536 218.104C293.768 224.216 296.84 232.96 296.84 237.824C297.043 244.52 297.642 251.198 298.632 257.824C299.432 262.432 301.192 264.224 304.52 264.736C307.848 265.248 311.72 264.224 312.712 262.176C313.704 260.128 316.04 248.576 316.04 240.416C316.04 232.256 316.04 223.464 316.312 217.056C316.406 212.119 316.23 207.181 315.784 202.264Z"
        fill="white"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M306.864 213.896C308.235 213.935 309.582 214.265 310.816 214.864"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M296.584 219.416C296.584 219.416 299.2 214.776 304.008 214.04"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M299.92 261.96C299.622 259.885 299.622 257.779 299.92 255.704C300.384 251.76 301.52 245.736 308.032 245.736C314.544 245.736 312.624 255.72 312.672 258.952C312.72 262.184 312.44 263.584 309.656 264.744C306.872 265.904 300.616 265.44 299.92 261.96Z"
        :fill="color"
        stroke="#263238"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_0_191">
        <rect width="400" height="400" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  import { getColor } from '../../mixins/getColor'

  export default {
    mixins: [getColor()]
  }
</script>

<style scoped>
  svg {
    position: absolute;
    z-index: -1;
    width: 300px;
  }
</style>
